import * as React from "react"
import parse from "html-react-parser"
import cx from "classnames"

import Container from "@components/elements/container"
import Cta from "@components/elements/cta"

import styles from "./simpleCtaSection.module.scss"

const SimpleCtaSection = ({ title, cta, variant }) => {
  return (
    <section className={cx(styles.simpleCtaSection, styles[variant])}>
      <Container className={styles.container}>
        <h2 className={styles.title}>{parse(title)}</h2>
        <Cta {...cta} className={styles.buttonCta} />
      </Container>
    </section>
  )
}

export default SimpleCtaSection
